<template>
  <b-row :class="{ cssClass }" class="m-0 mb-1">
    <b-col
      v-for="({ icon, label, content, variant, afterFixLabel,top }, index) in list"
      :key="index"
      md="6"
      class="mb-2"
    >
      <div class="d-flex" :class="{' align-items-center':!top,'align-items-start':top}">
        <sidebar-label :title="$t(label)" :icon="`ezAr-icon-${icon}`">
          <div class="d-flex">

            <label
              :style="getStyleObject(index)"
              
              class="font-weight-bold"
              >{{ $t(label) }} {{ afterFixLabel }}
            </label>
            <span class="font-weight-bold mr-1">:</span>
          </div>
        </sidebar-label>
        

          <span style="word-break: break-word;margin-top:2px" :class="{ [`text-${variant}`]: variant }">{{
            content
          }}</span>
        </div>
      
    </b-col>
  </b-row>
</template>
<script>
import SidebarLabel from "@/modules/SidebarLabel.vue";
import { defineComponent } from "@vue/composition-api";
import { get } from "@vueuse/core";
export default defineComponent({
  name: "GeneralInfo",
  components: {
    SidebarLabel,
  },
  props: {
    noCenter: Boolean,
    rightWidth:String,
    leftWidth:String,
    styleProp:Object,
    cssClass: String,
   
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    isEven(num) {
      return num % 2 === 0;
    },
    getStyleObject(index){
      
      return {
        width:this.isEven(index + 1) ? this.rightWidth : this.leftWidth,
        "min-width":this.isEven(index + 1) ? this.rightWidth : this.leftWidth,
       
      }
    }
  },
  computed:{
   
  }
});
</script>
